'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dPolicy$002dName$0024$0024anon$002484 from "./presto.types$-Policy-Name$$anon$84.js";
var $p;
/** @constructor */
function $c_Lpresto_types$PolicyName$() {
  this.c9r = null;
  this.c9s = false;
  this.c9p = null;
  this.c9q = false;
  this.c9v = null;
  this.c9w = false;
  this.c9t = null;
  this.c9u = false;
}
export { $c_Lpresto_types$PolicyName$ as $c_Lpresto_types$PolicyName$ };
$p = $c_Lpresto_types$PolicyName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$PolicyName$;
/** @constructor */
function $h_Lpresto_types$PolicyName$() {
}
export { $h_Lpresto_types$PolicyName$ as $h_Lpresto_types$PolicyName$ };
$h_Lpresto_types$PolicyName$.prototype = $p;
$p.cJe = (function() {
  if ((!this.c9s)) {
    this.c9r = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c9s = true;
  }
  return this.c9r;
});
$p.a33 = (function() {
  if ((!this.c9q)) {
    this.c9p = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.c9q = true;
  }
  return this.c9p;
});
$p.cJO = (function() {
  if ((!this.c9w)) {
    this.c9v = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c9w = true;
  }
  return this.c9v;
});
$p.ct2 = (function() {
  if ((!this.c9u)) {
    this.c9t = new $j_presto$002etypes$0024$002dPolicy$002dName$0024$0024anon$002484.$c_Lpresto_types$PolicyName$$anon$84(this);
    this.c9u = true;
  }
  return this.c9t;
});
$p.cFV = (function(original) {
  var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Predef$();
  var xs = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__split__T__I__AT(original, " ", 0);
  var evidence$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_reflect_ClassTag$().qV($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$objectGetClass(xs).aU.Q());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1.fl();
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_C.l());
  jsElems = [];
  var i = 0;
  while ((i < xs.b.length)) {
    var x1 = i;
    var x = xs.b[x1];
    if ((x !== "")) {
      var unboxedElem = (isCharArrayBuilder ? $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uC(x) : ((x === null) ? elementClass.aU.z : x));
      jsElems.push(unboxedElem);
    }
    i = ((1 + i) | 0);
  }
  var elemRuntimeClass = ((elementClass === $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_V.l()) ? $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_jl_Void.l() : (((elementClass === $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_sr_Null$.l()) || (elementClass === $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_sr_Nothing$.l())) ? $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_O.l() : elementClass));
  var filtered = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_IterableOnceOps__mkString__T__T__T__T($x_1.et(elemRuntimeClass.aU.r().w(jsElems)), "", " ", "");
  return ((!(!original.endsWith(" "))) ? (filtered + " ") : filtered);
});
var $d_Lpresto_types$PolicyName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$PolicyName$, "presto.types$PolicyName$", ({
  a0Y: 1,
  D: 1
}));
export { $d_Lpresto_types$PolicyName$ as $d_Lpresto_types$PolicyName$ };
var $n_Lpresto_types$PolicyName$;
function $m_Lpresto_types$PolicyName$() {
  if ((!$n_Lpresto_types$PolicyName$)) {
    $n_Lpresto_types$PolicyName$ = new $c_Lpresto_types$PolicyName$();
  }
  return $n_Lpresto_types$PolicyName$;
}
export { $m_Lpresto_types$PolicyName$ as $m_Lpresto_types$PolicyName$ };
//# sourceMappingURL=presto.types$-Policy-Name$.js.map
